module.exports = require("./src/js/huisstijl");